import { PlanTypes } from 'ui/utils/constants/maverick';
import { JOIN_FLOW_STEPS } from '@/lib/constants/maverick';
import { getMembershipInCart } from '../cart.utils';
import { getIsTypeFromAttributes } from '@/lib/utils/attributeHelper';
import type { CartButtonVariants } from './CartCTAButtons';
import { useGetCurrentPageMaverick } from '@/hooks/getCurrentPage';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { useShallow } from 'zustand/react/shallow';
import {
  useSharedButtonLogic,
  type UseSharedButtonLogicReturn,
} from './useSharedButtonLogic';

export interface UseJoinFlowButtonLogicReturn
  extends UseSharedButtonLogicReturn {
  buttonsVariant: CartButtonVariants;
}

interface UseJoinFlowButtonLogicProps {
  variant: CartButtonVariants;
  skipMemSelectFlow?: string;
  showTrialBlock?: boolean;
}

export function useJoinFlowButtonLogic({
  variant,
  skipMemSelectFlow,
  showTrialBlock = false,
}: UseJoinFlowButtonLogicProps): UseJoinFlowButtonLogicReturn {
  const { cart } = useSiteStore(
    useShallow((state) => ({
      cart: state.cart,
    })),
  );
  const page = useGetCurrentPageMaverick();
  const isMembershipPage = page === JOIN_FLOW_STEPS.MEMBERSHIP;

  // Check if trial membership is in cart
  const membershipInCart = getMembershipInCart(cart.cartItemGroups);
  const hasTrialInCart = membershipInCart
    ? getIsTypeFromAttributes(membershipInCart.attributes, PlanTypes.TRIAL)
    : false;

  // Determine button variant based on join flow specific logic
  let buttonsVariant = variant;
  if (hasTrialInCart && isMembershipPage) {
    buttonsVariant = showTrialBlock ? 'preferCheckout' : 'continueToCheckout';
  } else if (skipMemSelectFlow) {
    buttonsVariant = 'preferCheckout';
  }

  // Get shared button logic
  const sharedLogic = useSharedButtonLogic({
    isUpgradeFlow: false,
    buttonsVariant,
  });

  return {
    ...sharedLogic,
    buttonsVariant,
  };
}
